import type { JSX, ReactNode } from 'react'
import { AUTH_ROUTES } from './auth-routes'
import OnboardingPage from '../views/onboarding'
import GalleryPage from '../views/gallery'

export type Route = {
  name: string
  path: string
  icon?: ReactNode
  iconActive?: ReactNode
  component: () => JSX.Element
  metaTags?: {
    title: string
    description: string
  }
}

const PUBLIC_ROUTES: Route[] = [...AUTH_ROUTES]

const PRIVATE_ROUTES: Route[] = [
  {
    name: 'Onboarding',
    path: '/onboarding',
    component: OnboardingPage
  },
  {
    name: 'Gallery',
    path: '/gallery',
    component: GalleryPage
  }
]

export { PUBLIC_ROUTES, PRIVATE_ROUTES }
